import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBookingById } from "../Map/store/RoomMenu/RoomMenuThunks";
import { setInitialReservation, setShowReservationPopup, setUpdateRoom } from '../Map/store/RoomMenu/RoomMenuSlice.js';
import { setSelectedRoomupdate } from "../ControlPanel/store/AddEvent/AddEventSlice";
import { setOpenModal } from "../ControlPanel/store/controlPanelSlice";
import ConferenceParticipant from "./components/conferenceParticipant/ConferenceParticipant";
import ModerateParticipants from "./components/moderateParticipants/ModerateParticipants";
import ConferenceMessaging from "./components/conferenceMessages/ConferenceMessaging";
import { useTranslation } from "react-i18next";
import { setConferenceFunction, setIsConferencePanelOpen } from "./store/ActiveConferenceSlice";
import './ConferencePanel.css'
export default function ConferencePanel() {

    function useMobile() {
        const [isMobile, setIsMobile] = useState(window.innerWidth < 550);

        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth < 550);
            };

            window.addEventListener('resize', handleResize);

            // Nettoyage
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        return isMobile;
    }
    const isMobile = useMobile();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const {
        uiState,
        conference
    } = useSelector((state) => state.activeConference);
    const avatarsData = useSelector((state) => state.avatars?.avatars || {});
    const hands = useSelector((state) => state.raisedHands.list);
    const { conferenceMode } = useSelector((state) => state.livekit);

    const dispatch = useDispatch()
    const { t } = useTranslation();

    const startDate = uiState.conference_start_date;
    const conferenceId = conference.id;
    const [timerDisplay, setTimerDisplay] = useState("00:00:00");
    const stopConferenceButton = async () => {
        try {
            dispatch(setOpenModal("stop-conference"));

        } catch (error) {
            console.error(error);
        }
    };
    const handRanks = useMemo(() => {
        const ordered = [...hands].sort((a, b) => a.time - b.time);
        const ranks = {};

        ordered.forEach((h, index) => {
            const rank = index + 1;

            if (h.sender) ranks[h.sender] = rank;

            if (h.senderEmail) ranks[h.senderEmail] = rank;
        });

        return ranks;
    }, [hands]);

    const safeParticipants = Array.isArray(conference.participants) && Array.isArray(conference.participants[0])
        ? conference.participants[0]
        : (conference.participants || []);

    const joinedParticipants = safeParticipants.filter(p => avatarsData[p.user_id])
        .map(p => {
            const rank = handRanks[p.user_id] ?? handRanks[p.email] ?? null;
            const avatar = avatarsData[p.user_id] || {};
            const isHandRaised = hands.some(hand => hand.sender === p.user_id);
            const initials = avatar.firstName && avatar.lastName
                ? `${avatar.firstName[0]}${avatar.lastName[0]}`.toUpperCase()
                : (p.email ? p.email[0].toUpperCase() : "?");

            return {
                ...p,
                ...avatar,
                isHandRaised,
                rank,
                conference_user_id: p.id,
                initials
            };
        });


    useEffect(() => {
        let interval = null;

        if (uiState.is_conference_active && startDate) {
            const updateTimer = () => {
                const startTime = new Date(startDate).getTime();
                const now = new Date().getTime();
                const diffInSeconds = Math.floor((now - startTime) / 1000);

                if (diffInSeconds <= 0) {
                    setTimerDisplay("00:00:00");
                } else {
                    const hours = Math.floor(diffInSeconds / 3600).toString().padStart(2, '0');
                    const minutes = Math.floor((diffInSeconds % 3600) / 60).toString().padStart(2, '0');
                    const seconds = (diffInSeconds % 60).toString().padStart(2, '0');
                    setTimerDisplay(`${hours}:${minutes}:${seconds}`);
                }
            };
            updateTimer();
            interval = setInterval(updateTimer, 1000);
        } else {
            setTimerDisplay("00:00:00");
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [uiState.is_conference_active, startDate]);

    useEffect(() => {
        if (uiState.is_conference_active) {
            document.body.classList.add("in-active-conference");
        } else {
            document.body.classList.remove("in-active-conference");
        }

        return () => {
            document.body.classList.remove("in-active-conference");
        };
    }, [uiState.is_conference_active]);


    const updateConference = async () => {
        if (!conferenceId) {
            console.error("ID de conférence manquant");
            return;
        }
        else {
            console.log("conferenceId", conferenceId)
        }
        try {
            const data = await dispatch(
                getBookingById({ params: [{ bookingId: conferenceId }] })
            ).unwrap();
            dispatch(setInitialReservation(data));
            dispatch(setUpdateRoom(true));
            dispatch(setShowReservationPopup(true));
            dispatch(setSelectedRoomupdate(data.room_tenant))
            dispatch(setOpenModal("update_conference"));

        }
        catch (error) {
            console.error("Erreur récupération de la réservation :", error);
        }
    };
    return (
        <>
            {uiState.is_conference_active &&
                <div className="conference-panel"
                    style={{
                        height: uiState.is_conference_panel_open
                            ? (conferenceMode ? 'calc(100vh - 20px)' : 'calc(100vh - 160px)')
                            : 'auto',
                        background: uiState.is_conference_panel_open ? 'rgba(255, 255, 255, 0.85)' : 'none',
                        borderTop: uiState.is_conference_panel_open ? '0.125rem solid var(--Grey-modern-grey-200, #E3E8EF)' : 'none',
                        borderLeft: uiState.is_conference_panel_open ? '0.125rem solid var(--Grey-modern-grey-200, #E3E8EF)' : 'none',
                        borderRadius: uiState.is_conference_panel_open ? '0px 1rem 0px 0px' : 'none'
                    }}>
                    {uiState.is_conference_panel_open &&
                        <div className="conference-panel-body">
                            <div className="conference-panel-title">
                                <span className='conference-panel-title-text'>
                                    {uiState.conference_function === "participants" && (
                                        <span>{t('participants')}</span>
                                    )}

                                    {uiState.conference_function === "moderation" && (
                                        <span>{t('moderation_panel')}</span>
                                    )}
                                    {uiState.conference_function === "messages" && (
                                        <span>{t('messaging')}</span>
                                    )}
                                    {uiState.conference_function === "participants" && ` (${joinedParticipants.length})`}
                                </span>
                                <span className="material-symbols-outlined conference-panel-title-close" onClick={() => dispatch(setIsConferencePanelOpen(false))}>
                                    close
                                </span>
                            </div>
                            <div className="conference-panel-content"
                                style={{
                                    overflowY: uiState.conference_function === "messages" ? "unset" : "auto"
                                }}>
                                {uiState.conference_function === "participants" &&
                                    <ConferenceParticipant
                                        joinedParticipants={joinedParticipants}
                                    />
                                }
                                {uiState.conference_function === "moderation" &&
                                    <ModerateParticipants
                                        joinedParticipants={joinedParticipants}
                                    />
                                }
                                {uiState.conference_function === "messages" &&
                                    <ConferenceMessaging
                                        joinedParticipants={joinedParticipants}
                                    />
                                }

                            </div>
                        </div>}
                    <div className={`conference-original-functionnalities ${(isMobile && isMenuOpen) ? "menu-conference-open" : ""}`}>
                        <div className="conference-panel-header">
                            <span className='panel-title'>
                                {t('conference_mode')}
                            </span>
                            <div className='panel-time-container'>
                                <span className="material-symbols-outlined time-icon">
                                    album
                                </span>
                                <span className='panel-time'>
                                    {timerDisplay}
                                </span>

                                <span className='toggle-menu-conference-mobile' onClick={() => setIsMenuOpen(prev => !prev)}>
                                    <span class="material-symbols-outlined">
                                        keyboard_arrow_up
                                    </span>
                                </span>
                            </div>
                        </div>
                        {(!isMobile || isMenuOpen) &&
                            <div className=' conference-panel-buttons'>
                                {conference.allow_messages &&
                                    <button className={`control-btn conference-button conference-messages ${!(uiState.master.is_master || uiState.master.is_principal_master) ? 'for-guest' : ''} ${uiState.conference_function === "messages" ? 'active' : ''}}`} onClick={() => dispatch(setConferenceFunction("messages"))}>
                                        <span className="material-symbols-outlined panel-buttons ">
                                            stacked_email
                                        </span>
                                        {!(uiState.master.is_master || uiState.master.is_principal_master) && (
                                            <span className="label-guest">{t('messaging')}</span>
                                        )}
                                    </button>}
                                <button className={`control-btn conference-button conference-participants ${!(uiState.master.is_master || uiState.master.is_principal_master) ? 'for-guest' : ''} ${uiState.conference_function === "participants" ? 'active' : ''}`} onClick={() => dispatch(setConferenceFunction("participants"))}>
                                    <span className="material-symbols-outlined panel-buttons">
                                        group
                                    </span>
                                    {!(uiState.master.is_master || uiState.master.is_principal_master) && (
                                        <span className="label-guest"> {t('participants')}</span>
                                    )}
                                </button>
                                {(uiState.master.is_master || uiState.master.is_principal_master) && (
                                    <>
                                        <div className="vertical-divider"></div>
                                        <button
                                            className={`control-btn conference-button conference-moderation ${uiState.conference_function === "moderation" ? 'active' : ''}`}
                                            onClick={() => dispatch(setConferenceFunction("moderation"))}
                                        >
                                            <span className="material-symbols-outlined panel-buttons">
                                                manage_accounts
                                            </span>
                                        </button>
                                        <button className='control-btn conference-button conference-management' onClick={updateConference}>
                                            <span className="material-symbols-outlined panel-buttons">
                                                settings
                                            </span>
                                        </button>
                                        <button className='control-btn conference-exit-button conference-terminate' onClick={() => stopConferenceButton()} >
                                            <span className="material-symbols-outlined panel-buttons-close">
                                                login
                                            </span>
                                        </button>
                                    </>
                                )}
                            </div>
                        }
                    </div>


                </div>
            }
        </>
    );
}